<form>
	<mat-form-field color="accent" [subscriptSizing]="subScriptSizing()">
		<mat-label>{{ T.LABEL_MINUTES | translate }}</mat-label>
		<input matInput type="number" [formControl]="minCtrl" #minInput [min]="0" [max]="max()" />
		<mat-error>
			{{ T.ERROR_INVALID | translate: {item: T.LABEL_MINUTES | translate} }}
		</mat-error>
	</mat-form-field>
	:
	<mat-form-field color="accent" [subscriptSizing]="subScriptSizing()">
		<mat-label>{{ T.LABEL_SECONDS | translate }}</mat-label>
		<input matInput type="number" [formControl]="secCtrl" [min]="0" #secInput />
		<mat-error>{{ T.ERROR_INVALID | translate: {item: T.LABEL_SECONDS | translate} }}</mat-error>
	</mat-form-field>
</form>
